export default __webpack_public_path__ + "static/media/human-urinary.c5f72b2c.svg";